export const getTillsState = (state) => state.tills;

export const getTillState = (state) => state.till;
